class ddGroup {
  constructor(group) {
    if (
      group.matches('.is-loaded') ||
      group.parentElement.matches('.js-desktopDMN-DOM')
    ) {
      return;
    }
    this.group = group;
    this.controls = group.querySelectorAll('.js-drop-display');
    this.targets = group.querySelectorAll('.js-dropdown-display-item');
    this.group.classList.add('is-loaded');

    this.controls.forEach(control => {
      control.addEventListener('click', this.onClick);
    });
  }

  onClick = event => {
    event.preventDefault();
    const target = event.currentTarget.dataset.target;
    const DOMtarget = this.group.querySelector('.' + target);
    this.controls.forEach(target => target.classList.remove('active'));
    this.targets.forEach(target => target.classList.remove('active'));
    event.currentTarget.classList.add('active');
    DOMtarget.classList.add('active');
  };
}

const initMenu = () =>
  document
    .querySelectorAll('.dropdown-display-wrap')
    .forEach(group => new ddGroup(group));

initMenu();

export default initMenu;



// WEBPACK FOOTER //
// ./src/js/menu-display.js